import { NgModule } from '@angular/core';
import { ScientificArchiveDocumentComponent } from './scientific-archive-document.component';
import { ScientificArchiveDocumentDetailsComponent } from './scientific-archive-document-details/scientific-archive-document-details.component';
import { CommonModule, NgOptimizedImage } from '@angular/common';
import { ButtonModule } from 'primeng/button';
import { ScientificArchiveDocumentKeywordsComponent } from './scientific-archive-document-details/scientific-archive-document-keywords/scientific-archive-document-keywords.component';
import { ArchiveImageGalleryComponent } from './scientific-archive-document-details/archive-image-gallery/archive-image-gallery.component';
import { GalleriaModule } from 'primeng/galleria';
import { ToolbarModule } from 'primeng/toolbar';
import { MessagesModule } from 'primeng/messages';
import { TabletViewTabsModule } from '../shared/components/tablet-view-tabs/tablet-view-tabs.module';
import { SkeletonDocumentModule } from '../shared/components/skeleton-document/skeleton-document.module';
import { AccordionPanelModule } from '../shared/components/accordion-panel/accordion-panel.module';
import { ScientificArchiveMapModule } from '../shared/components/scientific-archive-map/scientific-archive-map.module';
import { CardScrollerModule } from '../shared/components/card-scroller/card-scroller.module';
import { TranslateModule } from '@ngx-translate/core';
import { SharedPipeModule } from '../shared/shared.module';


@NgModule({
    imports: [
        CommonModule,
        ButtonModule,
    
        AccordionPanelModule,
        GalleriaModule,
        ToolbarModule,
        MessagesModule,
        NgOptimizedImage,
        TabletViewTabsModule,
        SkeletonDocumentModule,
        ScientificArchiveMapModule,
        CardScrollerModule,
        SharedPipeModule,
        TranslateModule,
    ],
    declarations: [
        ScientificArchiveDocumentComponent,
        ScientificArchiveDocumentDetailsComponent,
        ScientificArchiveDocumentKeywordsComponent,
        ArchiveImageGalleryComponent
    ],
    exports: [
        ScientificArchiveDocumentComponent
    ]
})
export class ScientificArchiveDocumentModule { }